import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'types';

import logo from 'assets/images/lgads-logo.png';

import { HeaderStyles } from './style';
import UserInfo from 'reusable/UserInfo';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { navbarContext } from 'containers/App/Navbar/NavbarProvider';
import UserGuideLauncher from 'features/userGuide/components/UserGuideLauncher';

import { MdDoubleArrow } from 'react-icons/md';

const Header = () => {
  const { loggedIn, user } = useSelector((state: RootState) => state.session);
  const { collapsed, setCollapsed, headerTitle } = useContext(navbarContext);

  useEffect(() => {
    setCollapsed(true);
    return () => setCollapsed(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!headerTitle) return null;

  return (
    <HeaderStyles>
      {loggedIn && user.type === 'internal' ? (
        <div
          className="navbar-toggler"
          onClick={() => setCollapsed(prev => !prev)}
        >
          <MdDoubleArrow
            style={!collapsed ? { transform: 'rotateY(180deg)' } : undefined}
          />
        </div>
      ) : null}
      <Link to="/" className="logo-container">
        <Image src={logo} className="logo" />
      </Link>

      <div className="header">{headerTitle}</div>
      {loggedIn ? (
        <div className="header-actions">
          <UserGuideLauncher />
          <UserInfo />
        </div>
      ) : null}
    </HeaderStyles>
  );
};

export default Header;
